<template>
  <div>
    <transition name="scale-in" appear>
      <div class="error-modal-overlay" v-if="true">
        <div class="error-card">
          <div @click="closeModal" style="text-align: end">
            <VIcon :icon="'cross'" />
          </div>
          <div class="error-card-content">
            <div><VIcon :icon="'warning'" /></div>
            <div class="error-messages">{{ errorMessage }}</div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script lang="ts" setup>
import { useDataStore } from "@/stores/store.data";
import { GenericController } from "@/stores/controller";
import VIcon from "@/components/VIcon.vue";
import { computed, ref, onMounted } from "vue";
import { UserStoreFactory } from "@/stores/user";
import { fetchApiKey } from "@/stores/util.dom";

const storeData = useDataStore();
const typeofIssue = ref<string>(
  GenericController.CurrentController().typeOfError,
);
const apikey = fetchApiKey();
const useUserStore = UserStoreFactory(apikey + "_user");

let errorMessageTag = "{{_currentLang.labels.Error_message}}";

if (typeofIssue.value == "ERR_DUPLICATION") {
  errorMessageTag = "{{_currentLang.labels.Error_message2}}";
} else if (typeofIssue.value === "OHIP_ERROR") {
  errorMessageTag = "{{_currentLang.labels.Error_PMSGEP}}";
}

const errorMessage = computed(() => {
  if (typeofIssue.value === "ROOM_VALIDATION_ERROR") {
    return (
      GenericController.CurrentController().customErrorMessage ||
      storeData.resolveString(
        GenericController.CurrentController().name,
        "{{_currentLang.labels.Error_message}}",
        {},
      )
    );
  }
  return storeData.resolveString(
    GenericController.CurrentController().name,
    errorMessageTag,
    {},
  );
});
const closeModal = async () => {
  await GenericController.CurrentController().setErrorModal(false);
  await resetbutton();
  if (
    typeofIssue.value === "OHIP_ERROR" ||
    typeofIssue.value === "ROOM_VALIDATION_ERROR"
  ) {
    if (useUserStore().ohipGuestForm) {
      await GenericController.CurrentController().setModal(
        useUserStore().ohipGuestForm,
        true,
      );
    }
    if (useUserStore().closeForm) {
      await GenericController.CurrentController().setModal(
        useUserStore().closeForm,
        false,
      );
    }
    storeData.setControllerData("home", { rate_us_button_guest_form: true });

    const set = {
      luggage_down_button: true,
      luggage_down_button_guest_form: true,
      wakeup_call_button: true,
      wakeup_call_button_guest_form: true,
      clean_room_button: true,
      clean_room_button_guest_form: true,
      misc_button: true,
      misc_button_guest_form: true,
      report_issue_button: true,
      report_issue_button_guest_form: true,
      request_amenities_button_guest_form: true,
    };
    storeData.setControllerData("Assistance", set);
  }
};
const resetbutton = async () => {
  console.log(GenericController.CurrentController().name);
  const _resolved = { request_amenities_button: true };
  storeData.setControllerData(
    GenericController.CurrentController().name,
    _resolved,
  );
};
onMounted(async () => {
  typeofIssue.value = GenericController.CurrentController().typeOfError;
});
</script>

<style scoped>
.error-modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background-color: rgb(255 255 255 / 80%);
}

.error-card {
  background-color: white;
  width: 280px;
  padding: 20px;
  border-radius: 8px;
  box-shadow: rgb(0 0 0 / 20%) 0px 17.5px 70px;
  flex-direction: column;
  display: flex;
}
.error-card-content {
  margin: auto;
  display: flex;
  flex-direction: row;
  width: fit-content;
  padding: 0px 0px 10px 0px;
  gap: 14px;
  align-items: center;
}
.error-messages {
  margin: auto;
}
</style>
